import React, { useState } from 'react';

import { Popper, Placements } from '@videoblocks/storywind';

interface Props {
  id: string;
  imageUrl: string;
  onClickFunction: () => void;
  tooltipText: string;
}

const FolderActionButton = ({
  id,
  imageUrl,
  onClickFunction,
  tooltipText,
}: Props) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div>
      <Popper
        offset={[0, 8]}
        placement={Placements.Top}
        popperClasses="px-2 py-1 text-white bg-black rounded opacity-90 text-sm"
        showContent={showTooltip}
        triggerElement={(referenceElement) => (
          <img
            className={`bin-action ${tooltipText
              .toLowerCase()
              .split(' ')
              .join('-')}-icon`}
            src={imageUrl}
            alt="Folder Action Button"
            onKeyDown={onClickFunction}
            onClick={onClickFunction}
            onMouseEnter={() => setShowTooltip(true)}
            onFocus={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            onBlur={() => setShowTooltip(false)}
            ref={referenceElement}
            width={18}
            height={18}
          />
        )}
      >
        <div id={`tooltip-${id}`} className="whitespace-nowrap p-1">
          {tooltipText}
        </div>
      </Popper>
    </div>
  );
};

export default FolderActionButton;
